var DateUtils;
((DateUtils2) => {
  DateUtils2.create = (data) => new Date(data);
  DateUtils2.dayZeroTime = (data) => {
    const date = data ? new Date(data) : /* @__PURE__ */ new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  };
  DateUtils2.fullMilliSecond = () => (/* @__PURE__ */ new Date()).getTime();
  DateUtils2.fullSecond = () => (/* @__PURE__ */ new Date()).getTime() / 1e3;
  DateUtils2.milliSecond = () => (/* @__PURE__ */ new Date()).getMilliseconds();
  DateUtils2.format = (date, format2 = "yyyy-MM-dd HH:mm:ss") => {
    const pad = (num) => String(num).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    return format2.replace("yyyy", String(year)).replace("MM", month).replace("dd", day).replace("HH", hours).replace("mm", minutes).replace("ss", seconds);
  };
  DateUtils2.isSameDate = (date1, date2) => date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
  DateUtils2.compare = (date1, date2) => date1.getTime() < date2.getTime() ? -1 : date1.getTime() > date2.getTime() ? 1 : 0;
  DateUtils2.weekCountOfYear = (date) => {
    const currentDate = new Date(date.getTime());
    currentDate.setDate(currentDate.getDate() + 4 - (currentDate.getDay() || 7));
    const yearStart = new Date(currentDate.getFullYear(), 0, 1);
    const weekNo = Math.ceil(((currentDate.getTime() - yearStart.getTime()) / 864e5 + 1) / 7);
    return weekNo;
  };
  DateUtils2.age = (dateOfBirth, until = /* @__PURE__ */ new Date()) => {
    let age2 = until.getFullYear() - dateOfBirth.getFullYear();
    const m = until.getMonth() - dateOfBirth.getMonth();
    if (m < 0 || m === 0 && until.getDate() < dateOfBirth.getDate()) {
      age2--;
    }
    return Math.max(age2, 0);
  };
  DateUtils2.countingAge = (dateOfBirth, until = /* @__PURE__ */ new Date()) => {
    return Math.max(until.getFullYear() - dateOfBirth.getFullYear(), 0) + 1;
  };
  DateUtils2.add = ({ years = 0, months = 0, days = 0, minutes = 0, seconds = 0, milliSecond: milliSecond2 = 0 }, date) => {
    const result = date ? new Date(date) : /* @__PURE__ */ new Date();
    if (years) result.setFullYear(result.getFullYear() + years);
    if (months) result.setMonth(result.getMonth() + months);
    if (days) result.setDate(result.getDate() + days);
    if (minutes) result.setMinutes(result.getMinutes() + minutes);
    if (seconds) result.setSeconds(result.getSeconds() + seconds);
    if (milliSecond2) result.setMilliseconds(result.getMilliseconds() + milliSecond2);
    return result;
  };
  DateUtils2.toDate = (date) => {
    if (date instanceof Date) {
      return date;
    } else if (typeof date === "string" || typeof date === "number") {
      return new Date(date);
    } else {
      throw new Error("Invalid date type. Expected Date, string, or number.");
    }
  };
  DateUtils2.sinceSeconds = (date) => Math.floor((Date.now() - date.getTime()) / 1e3);
  DateUtils2.toSeconds = (date = /* @__PURE__ */ new Date()) => Math.floor(date.getTime() / 1e3);
  DateUtils2.toMilliseconds = (date = /* @__PURE__ */ new Date()) => date.getTime();
  DateUtils2.fromSeconds = (seconds) => new Date(seconds * 1e3);
  DateUtils2.fromMilliseconds = (milliseconds) => new Date(milliseconds);
  DateUtils2.toISOString = (date = /* @__PURE__ */ new Date()) => date.toISOString();
  DateUtils2.fromISOString = (isoString) => new Date(isoString);
  DateUtils2.formatDuration = (timeSecond, locale = (0, DateUtils2.getDefaultLocale)()) => {
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "always", style: "long" });
    let remaining = timeSecond;
    const days = Math.floor(remaining / 86400);
    remaining -= days * 86400;
    const hours = Math.floor(remaining / 3600);
    remaining -= hours * 3600;
    const minutes = Math.floor(remaining / 60);
    remaining -= minutes * 60;
    const seconds = remaining;
    const result = [];
    if (days > 0) {
      result.push(rtf.format(days, "day").replace("\uD6C4", "").replace("in ", "").replace("dans ", ""));
    }
    if (hours > 0) {
      result.push(rtf.format(hours, "hour").replace("\uD6C4", "").replace("in ", "").replace("dans ", ""));
    }
    if (minutes > 0) {
      result.push(rtf.format(minutes, "minute").replace("\uD6C4", "").replace("in ", "").replace("dans ", ""));
    }
    if (seconds > 0 || result.length === 0) {
      result.push(rtf.format(seconds, "second").replace("\uD6C4", "").replace("in ", "").replace("dans ", ""));
    }
    return result.join(" ");
  };
  DateUtils2.relativeTime = (date, config) => {
    const rtf = new Intl.RelativeTimeFormat(config?.locales, config?.options);
    let targetDate;
    if (!(date instanceof Date)) {
      targetDate = new Date(date);
    } else {
      targetDate = date;
    }
    const now = /* @__PURE__ */ new Date();
    const diffMs = targetDate.getTime() - now.getTime();
    const absDiffMinutes = Math.floor(Math.abs(diffMs) / (1e3 * 60));
    const absDiffHours = Math.floor(Math.abs(diffMs) / (1e3 * 60 * 60));
    const absDiffDays = Math.floor(Math.abs(diffMs) / (1e3 * 60 * 60 * 24));
    if (diffMs === 0) {
      return rtf.format(0, "seconds");
    }
    if (diffMs < 0) {
      if (absDiffMinutes < 1) {
        return rtf.format(-Math.floor(Math.abs(diffMs) / 1e3), "seconds");
      } else if (absDiffMinutes < 60) {
        return rtf.format(-absDiffMinutes, "minutes");
      } else if (absDiffHours < 24) {
        return rtf.format(-absDiffHours, "hours");
      } else {
        return rtf.format(-absDiffDays, "days");
      }
    } else {
      if (absDiffMinutes < 1) {
        return rtf.format(Math.floor(diffMs / 1e3), "seconds");
      } else if (absDiffMinutes < 60) {
        return rtf.format(absDiffMinutes, "minutes");
      } else if (absDiffHours < 24) {
        return rtf.format(absDiffHours, "hours");
      } else {
        return rtf.format(absDiffDays, "days");
      }
    }
  };
  DateUtils2.getDefaultLocale = () => Intl.DateTimeFormat().resolvedOptions().locale;
})(DateUtils || (DateUtils = {}));
export {
  DateUtils
};
//# sourceMappingURL=DateUtils.js.map
